import React, { useState } from 'react';

import Collapse from '@kunukn/react-collapse';
import classNames from 'classnames';

import Icon from '@components/Icon';
import Link from '@components/Link';
import { MemberResultProps } from '@presenters/web/pages/Clubs/Members/utils';

import { useTranslation } from '@external/react-i18next';

const ResultsListMobile: React.FC<MemberResultProps> = ({
  id,
  name,
  email,
  phone,
  role,
  type,
  date,
  status,
}) => {
  const { t } = useTranslation();

  const isOpened = false;

  const [isExpanded, setIsExpanded] = useState(isOpened);

  const handleClick = () => setIsExpanded(!isExpanded);

  return (
    <div
      data-label="RosterResult"
      className={classNames(`member-row-mobile desktop:hidden w-full px-5`, {
        'bg-bright-blue-100 pb-8 -my-4 pt-5': isExpanded,
        'member-row-mobile--expanded': isExpanded,
      })}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => handleClick()}
        className="relative w-full member-row-info flex items-center text-left text-xs font-normal leading-6 focus:shadow-none tap-highlight-color-transparent overflow-hidden"
        data-testid="toggle-expand-btn"
      >
        <div className="w-4/6">
          <div
            className={classNames('mr-auto self-center flex-auto', {
              'w-full': !email,
            })}
          >
            <div className="flex-1 text-xs leading-6">
              <h3
                className={classNames(
                  'font-bold text-md mb-0 desktop:absolute desktop:-mt-4',
                  {
                    underline: true,
                  }
                )}
              >
                <Link
                  noLinkStyles
                  to={`/${type}/${id}/manage-membership/candidate-details`}
                >
                  {name}
                </Link>
              </h3>
              <div className="mt-2">
                {email ? (
                  <span className="text-xs mb-0 truncate">
                    <a href={`mailto:${email}`}>{email}</a>
                  </span>
                ) : (
                  <span className="text-xs mb-0" />
                )}
              </div>
            </div>
            <div className="mt-2">
              {phone ? (
                <span className="text-xs text-gray-400 mb-0">{phone}</span>
              ) : (
                <span className="text-xs mb-0" />
              )}
            </div>
          </div>
        </div>
        <div
          aria-hidden="true"
          className={classNames('absolute right-0 absolute-vertical-center', {
            hidden: isExpanded,
          })}
        >
          <Icon name="arrows/down" size="17" color="black" />
        </div>
        <div
          aria-hidden="true"
          className={classNames('absolute right-0 top-1', {
            hidden: !isExpanded,
          })}
        >
          <Icon
            data-testid="arrow-Exp"
            name="ui/close"
            size="17"
            color="black"
          />
        </div>
      </div>

      <Collapse isOpen={isExpanded} className="collapse-css-transition">
        <div className="w-full mt-3 overflow-hidden">
          <span className="text-xs mb-0 text-gray-600">{role}</span>
        </div>
        <div className="mt-2">
          <span className="mb-0 text-xs text-gray-600">
            {t('mml.member.submitted-date', 'Submitted')} {date}
          </span>
        </div>
        <div className="flex flex-col mt-2 self-center flex-1 leading-6 w-full mr-4">
          <span className="text-xs mb-0 text-gray-600">{status}</span>
        </div>
        <div className="text-xs leading-6 mt-5">
          <Link
            to={`/${type}/${id}/manage-membership/candidate-details`}
            className="text-xs mb-0"
          >
            {t('mml.member.view.candidate-details', 'View candidate details')}
          </Link>
        </div>
      </Collapse>
    </div>
  );
};

export default ResultsListMobile;
